var _style, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.text {\r\n\t\tfont: 13px sans-serif;\r\n\t\tfill: white;\r\n\t\tfont-weight: bold;\r\n\t\t}\r\n\t")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC999E"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5364"
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 52,
    className: "text"
  }, "\r\n\t\t\tMP4\r\n\t\t")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8BDB8"
    },
    d: "M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13 c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20 s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8BDB8"
    },
    d: "M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7 c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9D7CA"
    },
    points: "37.5,0.151 37.5,12 49.349,12  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMp4);
export default __webpack_public_path__ + "static/media/file-mp4.b00410aea1a1603501b73c2df404f399.svg";
export { ForwardRef as ReactComponent };